import {useMemo, useState} from "react";
import {ServiceTypeModeEntity} from "@ots-frontend/ots-data";
import {useDebouncedValue} from "@mantine/hooks";
import {
  DataTableFilterConfig,
  useDataTableFilter,
  UseDataTableFilterProps,
  UseDataTableFilterResult
} from "../DataTable/useDataTableFilter";
import {useTranslation} from "react-i18next";

export type UseServiceTypeModeDataTableFilterProps = Omit<UseDataTableFilterProps<ServiceTypeModeEntity>, 'filterConfig'>

export function useServiceTypeModeDataTableFilter(props: UseServiceTypeModeDataTableFilterProps): UseDataTableFilterResult<ServiceTypeModeEntity> {
  const {records} = props;

  const {t} = useTranslation(["common"])

  const [modeQuery, setModeQuery] = useState<string | undefined>(undefined);
  const [modeDebouncedQuery] = useDebouncedValue(modeQuery, 200);

  const filterConfig: DataTableFilterConfig<ServiceTypeModeEntity> = useMemo(() => {
    return {
      "mode": {
        setQuery: setModeQuery,
        query: modeQuery,
        debouncedQuery: modeDebouncedQuery,
        filter: (record, query) => !record.mode.toLowerCase().includes(query.toLowerCase())
      },
    }
  }, [
    modeQuery,
    modeDebouncedQuery,
    t
  ])

  const {filteredRecords} = useDataTableFilter({
    records: records,
    filterConfig: filterConfig,
  })

  return {
    filteredRecords: filteredRecords,
    filterConfig: filterConfig
  };
}
